<template>
  <BarChart
    :request-status="requestStatus"
    :categories="categories"
    :series="series"
    :title="title"
    :item-id="itemId"
    :card-options="cardOptions"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import BarChart from '@/components/cards/models/BarChart';
import { ENTITIES, SAC_STATUS_FIELDS, OPERATION } from '@/services/charts-service';
import EventBus from '@/utils/event-bus';
import { mapActions, mapGetters } from 'vuex';
import proprietaryModel from '@/mixins/proprietary-model';
import highchartsBasics from '@/mixins/highcharts-basics';
import colors from '@/utils/colors';
import { msToTime } from '@/utils/date';
import { getTitlesAndChannels } from '@/utils/pages';

export default {
  name: 'SacAverageTimeForTreatmentsByOperator',
  components: {
    BarChart,
  },
  mixins: [
    proprietaryModel,
    highchartsBasics,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    isExpandedCard: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      rawData: {},
      cardOptions: {
        plotOptions: {
          series: {
            stacking: 'normal',
          },
        },
        yAxis: {
          stackLabels: {
            formatter() {
              return msToTime(this.total);
            },
          },
        },
        tooltip: {
          pointFormatter() {
            const { y, color, series } = this;
            const value = msToTime(y);
            return `<span style="color:${color}">●</span> ${series.name}: <b>${value}</b><br/>`;
          },
        },
      },
    };
  },
  computed: {
    ...mapGetters('dashboard', [
      'pages',
    ]),
    pageIds() {
      return this.rawData.axes?.find(({ label }) => label === SAC_STATUS_FIELDS.pageId)?.values || [];
    },
    categories() {
      return getTitlesAndChannels(this.pageIds, this.pages);
    },
    series() {
      if (!this.rawData?.points) {
        return [];
      }
      const data = this.isExpandedCard ? this.rawData.points[0]?.data : this.rawData.points[0]?.data.slice(0, this.maxItemsToBeDisplayed);

      return [
        {
          name: this.$t('mixins.cardsModel.averageTime'),
          color: colors.defaultSerieColor,
          data,
        },
      ];
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getChartsService',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      this.getChartsService({
        itemId: this.itemId,
        method: 'getAggregatedData',
        entity: ENTITIES.SAC_STATUS,
        params: {
          fields: [SAC_STATUS_FIELDS.statusChangeTime],
          operators: OPERATION.AVG,
          grouping: [
            SAC_STATUS_FIELDS.pageId,
          ],
        },
      })
        .then((response) => {
          this.rawData = response;

          this.requestStatus = 'success';

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch((err) => {
          console.error(err);
          this.requestStatus = 'error';
        });
    },
  },
};
</script>
